import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import Cookies from 'universal-cookie';
import Logger from '../logger';
import onlyDefinedProps from '../onlyDefinedProps';
import parseStringToBoolean from '../parseStringToBoolean';
import whereAmI from '../whereAmI';
export var parseAccountDataClient = function parseAccountDataClient(data, logger) {
  var isBrowser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : whereAmI.onClient;
  if (isBrowser) {
    try {
      if (_typeof(data) === 'object') {
        return data;
      }
      return data ? JSON.parse(decodeURIComponent(data)) : undefined;
    } catch (e) {
      logger.error("Invalid cookie ml2_sid_c = ".concat(data));
    }
  }
  return undefined;
};
var rewritePmdStore = function rewritePmdStore(_ref) {
  var _settings$config, _settings$config$publ, _settings$config$publ2;
  var ctx = _ref.ctx,
    location = _ref.location,
    settings = _ref.settings,
    storeName = _ref.storeName;
  if ((ctx == null ? void 0 : ctx.siteId) === 'parceiromagalu' || (ctx == null ? void 0 : ctx.siteId) === 'parceiromagalu-mobile' || location.includes(settings == null ? void 0 : (_settings$config = settings.config) == null ? void 0 : (_settings$config$publ = _settings$config.publicRuntimeConfig) == null ? void 0 : (_settings$config$publ2 = _settings$config$publ.parceiromagalu) == null ? void 0 : _settings$config$publ2.domain)) {
    return "".concat(storeName.replace('magazine', ''), "/");
  }
  return storeName;
};
export var parseLoyaltyData = function parseLoyaltyData(promoterData, ctx, settings) {
  var _ctx$req, _window, _window$location;
  var _ref2 = (promoterData == null ? void 0 : promoterData.split('|')) || [],
    _ref3 = _slicedToArray(_ref2, 2),
    storeName = _ref3[0],
    pmdPromoter = _ref3[1];
  if (!storeName || !pmdPromoter) return undefined;
  var location = (ctx == null ? void 0 : (_ctx$req = ctx.req) == null ? void 0 : _ctx$req.url) || ((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.href);
  var store = rewritePmdStore({
    ctx: ctx,
    location: location,
    settings: settings,
    storeName: storeName
  });
  if (!location || !location.includes(store)) return undefined;
  return pmdPromoter;
};
export var parsePromoterData = function parsePromoterData(promoterData) {
  var _ref4 = (promoterData == null ? void 0 : promoterData.split('|')) || [],
    _ref5 = _slicedToArray(_ref4, 3),
    pmdStore = _ref5[0],
    pmdPromoter = _ref5[1],
    pmdName = _ref5[2];
  if (!pmdStore || !pmdPromoter) return undefined;
  return {
    loyalty: pmdPromoter,
    name: pmdName,
    store: pmdStore
  };
};
export var parseShowcaseName = function parseShowcaseName(mvcShowcaseName) {
  if (!mvcShowcaseName) return undefined;
  return mvcShowcaseName.replace('magazine', '').toLowerCase();
};
var useCookies = function useCookies() {
  var _ctx$req2, _ctx$req2$headers;
  var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var logger = settings.logger || Logger((settings == null ? void 0 : settings.config) || {});
  var cookies = whereAmI.onClient ? new Cookies() : new Cookies(ctx == null ? void 0 : (_ctx$req2 = ctx.req) == null ? void 0 : (_ctx$req2$headers = _ctx$req2.headers) == null ? void 0 : _ctx$req2$headers.cookie);
  var _cookies$getAll = cookies.getAll(),
    alternativeZipCode = _cookies$getAll.alternative_zipcode,
    acceptPolicy = _cookies$getAll.cookie_accept_policy,
    zipCode = _cookies$getAll.zipcode,
    zipCodeChecksum = _cookies$getAll.zipcode_checksum,
    zipCodeCity = _cookies$getAll.zipcode_city,
    zipCodeState = _cookies$getAll.zipcode_state,
    zipCodeLatitude = _cookies$getAll.zipcode_latitude,
    zipCodeLongitude = _cookies$getAll.zipcode_longitude,
    partnerId = _cookies$getAll.MLPARCEIRO,
    customerId = _cookies$getAll.stwu,
    gatekeeperExhibitionRule = _cookies$getAll.gatekeeper_exhibition,
    trackId = _cookies$getAll.ml_tid,
    accountDataEncoded = _cookies$getAll.ml2_sid_c,
    cartId = _cookies$getAll.ml2_sid,
    clientId = _cookies$getAll._ga,
    mvcShowcaseName = _cookies$getAll.mvc_showcase_name,
    promoterData = _cookies$getAll.pmd_promoter,
    promoterId = _cookies$getAll.promoter_id,
    togglePdpSellerScore = _cookies$getAll.toggle_pdp_seller_score,
    toggleSharePromoterOfferLink = _cookies$getAll.toggle_share_promoter_offer_link,
    toggleRemovePromoterOfferTabs = _cookies$getAll.toggle_remove_promoter_offer_tabs,
    toggleShipping = _cookies$getAll.mixer_shipping,
    toggleWishlist = _cookies$getAll.toggle_wishlist,
    searchExperiment = _cookies$getAll.search_experiment,
    magaluExperiment = _cookies$getAll.ml_exp,
    rejectZipcodePopup = _cookies$getAll.cookie_reject_zipcode_popup,
    toggleAgatha = _cookies$getAll.toggle_agatha,
    toggleAds = _cookies$getAll.toggle_ads,
    toggleNewServicePage = _cookies$getAll.toggle_new_service_page,
    toggleQuickClick = _cookies$getAll.toggle_quick_click,
    toggleCardan = _cookies$getAll.toggle_cardan,
    toggleWhatsappButton = _cookies$getAll.toggle_whatsapp_button,
    abtestPrebasket = _cookies$getAll.abtest_prebasket;
  var location = {
    alternativeZipCode: alternativeZipCode,
    zipCode: zipCode,
    zipCodeChecksum: zipCodeChecksum,
    zipCodeCity: zipCodeCity && decodeURIComponent(zipCodeCity),
    zipCodeLatitude: zipCodeLatitude,
    zipCodeLongitude: zipCodeLongitude,
    zipCodeState: zipCodeState
  };
  return onlyDefinedProps({
    abtestPrebasket: abtestPrebasket,
    acceptPolicy: acceptPolicy,
    accountData: parseAccountDataClient(accountDataEncoded, logger),
    cartId: cartId,
    clientId: clientId,
    customerId: customerId,
    gatekeeperExhibitionRule: gatekeeperExhibitionRule,
    location: location,
    magaluExperiment: magaluExperiment,
    mvcShowcaseName: parseShowcaseName(mvcShowcaseName),
    partnerId: partnerId,
    pmdPromoter: parseLoyaltyData(promoterData, ctx, settings),
    promoterData: parsePromoterData(promoterData),
    promoterId: promoterId,
    rejectZipcodePopup: rejectZipcodePopup,
    searchExperiment: searchExperiment,
    toggleAds: parseStringToBoolean(toggleAds, false),
    toggleAgatha: parseStringToBoolean(toggleAgatha, false),
    toggleCardan: parseStringToBoolean(toggleCardan, false),
    toggleNewServicePage: parseStringToBoolean(toggleNewServicePage, true),
    togglePdpSellerScore: parseStringToBoolean(togglePdpSellerScore, true),
    toggleQuickClick: parseStringToBoolean(toggleQuickClick, false),
    toggleRemovePromoterOfferTabs: parseStringToBoolean(toggleRemovePromoterOfferTabs, true),
    toggleSharePromoterOfferLink: toggleSharePromoterOfferLink,
    toggleShipping: toggleShipping,
    toggleWhatsappButton: parseStringToBoolean(toggleWhatsappButton, false),
    toggleWishlist: parseStringToBoolean(toggleWishlist, true),
    trackId: trackId
  });
};
export default useCookies;